module.exports = ".page-content {\r\n    margin-left: 21.5%;\r\n    margin-top: .5%;\r\n}"